module.exports = __webpack_public_path__ + "static/media/Kingler_gaussian2.bf69ca48.png";